import React from 'react';
import AdminDashboard from '../Dashboard/AdminDashboard';

// This component reuses the AdminDashboard since it already handles pending approvals
const PendingApprovals: React.FC = () => {
  return <AdminDashboard />;
};

export default PendingApprovals;